import { CONFIG } from '../config';
import type { Settings } from '../ui/Phone';

const isTouch = (): boolean =>
  typeof window !== 'undefined' && window.matchMedia?.('(pointer: coarse)').matches === true;

/** Phones get shadows off by default; everything else gets the full look. */
export function defaultSettings(): Settings {
  return { music: 0.55, sfx: 0.8, shadows: !isTouch(), sway: true, firstPerson: false, invertY: false };
}

export function loadSettings(): Settings {
  const defaults = defaultSettings();
  try {
    const raw = localStorage.getItem(CONFIG.settingsKey);
    return raw ? { ...defaults, ...(JSON.parse(raw) as Partial<Settings>) } : defaults;
  } catch {
    return defaults;
  }
}

export function storeSettings(s: Settings): void {
  try {
    localStorage.setItem(CONFIG.settingsKey, JSON.stringify(s));
  } catch {
    // Settings are a convenience; ignore storage failures (private mode etc).
  }
}
